import React, { useState } from 'react';
import { Link } from 'react-router-dom'; 
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import urls from '../../../config/urls';

function MobileNav() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="mobileNavAlt">
      <Button
        id="basic-button"
        variant='outlined'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        Menu
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem className="nav-alt" onClick={handleClose}>
          <Link to={urls.magdalaLandingPage}>About</Link>
        </MenuItem>
        <MenuItem className="nav-alt" onClick={handleClose}>
          <Link to={urls.magdalaProgramPage}>Program</Link>
        </MenuItem>
        <MenuItem className="nav-alt" onClick={handleClose}>
          <Link to={urls.magdalaCoursesPage}>Courses</Link>
        </MenuItem>
        <MenuItem className="nav-alt" onClick={handleClose}>
          <Link to={urls.magdalaCurriculumPage}>Curriculum</Link>
        </MenuItem>
      </Menu>
    </div>
  );
}

export default MobileNav; 